"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Table = _interopRequireDefault(require("../appComponents/Table"));

var _Button = _interopRequireDefault(require("../baseComponents/Button"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ExpandingTable = /*#__PURE__*/function (_Component) {
  _inherits(ExpandingTable, _Component);

  var _super = _createSuper(ExpandingTable);

  function ExpandingTable(props) {
    var _this;

    _classCallCheck(this, ExpandingTable);

    _this = _super.call(this, props);
    _this.state = {
      rowsState: props.tableContent.map(function (row) {
        return row[0].hidden;
      })
    };
    _this.refsArray = _toConsumableArray(Array(props.tableContent.length)).map(function () {
      return /*#__PURE__*/_react["default"].createRef();
    });
    _this.showHide = _this.showHide.bind(_assertThisInitialized(_this));
    _this.onCancel = _this.onCancel.bind(_assertThisInitialized(_this));
    _this.onSave = _this.onSave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ExpandingTable, [{
    key: "showHide",
    value: function showHide(rowInformation, index) {
      var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (show && this.state.rowsState[index] || !show && !this.state.rowsState[index]) return;

      if (show && this.props.shouldRowOpen && !this.props.shouldRowOpen()) {
        return;
      }

      var newRowsState = this.state.rowsState;
      newRowsState[index] = show; // calling a callback after showing the hidden content

      setTimeout(function () {
        return rowInformation[1].onExpand && show && rowInformation[1].onExpand();
      });
      this.setState({
        rowsState: newRowsState
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel(e, rowInformation, index, callback) {
      this.showHide(rowInformation, index, false);
      var cancelBtn = rowInformation[1].cancelBtn ? rowInformation[1].cancelBtn : {};

      if (cancelBtn.onClick) {
        cancelBtn.onClick(e, rowInformation, index);
      } else if (this.props.defaultCancelBtn.onClick) {
        this.props.defaultCancelBtn.onClick(e, rowInformation, index);
      }
    }
  }, {
    key: "onSave",
    value: function onSave(e, rowInformation, index, callback, btnRef) {
      var saveBtn = rowInformation[1].saveBtn ? rowInformation[1].saveBtn : {};

      if (saveBtn.closeOnSave === true || saveBtn.closeOnSave == null && this.props.defaultCloseOnSave) {
        this.showHide(rowInformation, index, false);
      }

      if (saveBtn.onClick) {
        saveBtn.onClick(e, rowInformation, index, btnRef);
      } else if (this.props.defaultSaveBtn.onClick) {
        this.props.defaultSaveBtn.onClick(e, rowInformation, index, btnRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var content = this.props.tableContent.map(function (row, rowIndex) {
        var cols = [];
        var isHidden = _this2.state.rowsState[rowIndex];
        var rowIsDisabled = row[0].disabled;
        var hasHiddenContent = row[0].hiddenContent || row[1].hiddenContent;
        var infoClasses = (0, _classnames["default"])("infoContainer", "row" + rowIndex, _this2.props.expandableClickArea, {
          hidden: isHidden,
          noHiddenContent: !hasHiddenContent
        });
        var hiddenContentClass = (0, _classnames["default"])("editInfoContainer", "row" + rowIndex, _this2.props.expandableClickArea, {
          hidden: !isHidden,
          noHiddenContent: !hasHiddenContent
        });
        var columnClass = (0, _classnames["default"])("column", {
          disabled: rowIsDisabled
        });
        var iconName = _this2.props.iconName;
        var iconType = _this2.props.iconType;

        if (rowIsDisabled) {
          iconName = _this2.props.disabledIconName;
          iconType = _this2.props.disabledIconType;
        }

        if (row[0]) {
          var isClickArea = ["left", "both"].indexOf(_this2.props.expandableClickArea) > -1;
          var isExpandableArea = isClickArea && hasHiddenContent;
          cols.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: columnClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: infoClasses,
            onClick: isExpandableArea ? function () {
              _this2.showHide(row, rowIndex, true);
            } : function () {}
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[0].title && /*#__PURE__*/_react["default"].createElement("h6", null, row[0].title), row[0].text && /*#__PURE__*/_react["default"].createElement("p", {
            className: "narrow"
          }, row[0].text)), (_this2.props.showHoverIcon && isExpandableArea || rowIsDisabled && isClickArea) && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            name: iconName,
            type: iconType
          })), row[0].hiddenContent && /*#__PURE__*/_react["default"].createElement("div", {
            className: hiddenContentClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[0].hiddenContent))));
        }

        if (row[1]) {
          var _isClickArea = ["right", "both"].indexOf(_this2.props.expandableClickArea) > -1;

          var _isExpandableArea = _isClickArea && hasHiddenContent;

          var cancelBtn = row[1].cancelBtn ? row[1].cancelBtn : {};
          var saveBtn = row[1].saveBtn ? row[1].saveBtn : {};
          cancelBtn = {
            onClick: cancelBtn.onClick ? cancelBtn.onClick : _this2.props.defaultCancelBtn.onClick,
            text: cancelBtn.text ? cancelBtn.text : _this2.props.defaultCancelBtn.text
          };
          saveBtn = {
            onClick: saveBtn.onClick ? saveBtn.onClick : _this2.props.defaultSaveBtn.onClick,
            text: saveBtn.text ? saveBtn.text : _this2.props.defaultSaveBtn.text,
            animated: saveBtn.hasOwnProperty("animated") ? saveBtn.animated : _this2.props.defaultSaveBtn.animated,
            animateOnClick: saveBtn.hasOwnProperty("animateOnClick") ? saveBtn.animateOnClick : _this2.props.defaultSaveBtn.animateOnClick,
            loadingText: saveBtn.loadingText ? saveBtn.loadingText : _this2.props.defaultSaveBtn.loadingText,
            doneText: saveBtn.doneText ? saveBtn.doneText : _this2.props.defaultSaveBtn.doneText,
            disabled: saveBtn.hasOwnProperty("disabled") ? saveBtn.disabled : _this2.props.defaultSaveBtn.disabled,
            closeOnSave: saveBtn.hasOwnProperty("closeOnSave") ? saveBtn.closeOnSave : _this2.props.defaultSaveBtn.closeOnSave
          };
          cols.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: columnClass
          }, row[1].information && /*#__PURE__*/_react["default"].createElement("div", {
            className: infoClasses,
            onClick: _isExpandableArea ? function () {
              _this2.showHide(row, rowIndex, true);
            } : function () {}
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[1].information), (_this2.props.showHoverIcon && _isExpandableArea || rowIsDisabled && _isClickArea) && /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
            name: iconName,
            type: iconType
          })), row[1].hiddenContent && /*#__PURE__*/_react["default"].createElement("div", {
            className: hiddenContentClass
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "contentContainer"
          }, row[1].hiddenContent, /*#__PURE__*/_react["default"].createElement("div", {
            className: "buttons"
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            colorTheme: "grey",
            size: "small",
            tabIndex: 1,
            type: "submit",
            onClick: function onClick(e) {
              _this2.onCancel(e, row, rowIndex, cancelBtn.onClick);
            },
            shapeStyle: "stroke",
            radius: "square"
          }, cancelBtn.text), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            onClick: function onClick(e) {
              _this2.onSave(e, row, rowIndex, saveBtn.onClick, _this2.refsArray[rowIndex]);
            },
            text: saveBtn.text,
            tabIndex: 2,
            ref: function ref(_ref) {
              _this2.refsArray[rowIndex] = _ref;
            },
            animated: saveBtn.animated,
            animateOnClick: saveBtn.animateOnClick,
            loadingText: saveBtn.loadingText,
            doneText: saveBtn.doneText,
            disabled: saveBtn.disabled,
            radius: "square",
            colorTheme: "teal",
            shapeStyle: "fill",
            size: "small"
          }))))));
        }

        return cols;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "expending-table-component"
      }, /*#__PURE__*/_react["default"].createElement(_Table["default"], {
        disabled: this.props.disabled,
        style: this.props.style,
        className: this.props.className,
        textAlign: this.props.textAlign,
        tableContent: content
      }));
    }
  }]);

  return ExpandingTable;
}(_react.Component);

;
ExpandingTable.propTypes = {
  tableContent: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].array]),
    hiddenContent: _propTypes["default"].any,
    hidden: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    onExpand: _propTypes["default"].func
  }), _propTypes["default"].shape({
    information: _propTypes["default"].any,
    hiddenContent: _propTypes["default"].any,
    cancelBtn: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
    }),
    saveBtn: _propTypes["default"].shape({
      onClick: _propTypes["default"].func,
      text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      animated: _propTypes["default"].bool,
      animateOnClick: _propTypes["default"].bool,
      loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
      disabled: _propTypes["default"].bool,
      closeOnSave: _propTypes["default"].bool
    })
  }))),
  defaultCloseOnSave: _propTypes["default"].bool,
  defaultCancelBtn: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  }),
  defaultSaveBtn: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    animated: _propTypes["default"].bool,
    animateOnClick: _propTypes["default"].bool,
    loadingText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    doneText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    disabled: _propTypes["default"].bool,
    closeOnSave: _propTypes["default"].bool
  }),
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  textAlign: _propTypes["default"].oneOf(["", "text-align-left", "text-align-right"]),
  expandableClickArea: _propTypes["default"].oneOf(["left", "right", "both"]),
  showHoverIcon: _propTypes["default"].bool,
  iconName: _propTypes["default"].string,
  iconType: _propTypes["default"].string,
  disabledIconName: _propTypes["default"].string,
  disabledIconType: _propTypes["default"].string,
  shouldRowOpen: _propTypes["default"].func
};
ExpandingTable.defaultProps = {
  tableContent: [],
  defaultCloseOnSave: false,
  defaultCancelBtn: {
    onClick: null,
    text: ""
  },
  defaultSaveBtn: {
    onClick: null,
    text: null,
    animated: true,
    animateOnClick: true,
    loadingText: null,
    doneText: null,
    disabled: false,
    closeOnSave: false
  },
  disabled: false,
  className: "",
  style: {},
  textAlign: "text-align-left",
  expandableClickArea: "left",
  showHoverIcon: false,
  iconName: "glyph-edit",
  iconType: "glyph",
  disabledIconName: "glyph-lock",
  disabledIconType: "glyph",
  shouldRowOpen: null
};
var _default = ExpandingTable;
exports["default"] = _default;